import "./NursingCareProviderInAshkelonWithinFiveHours.module.css";
import Header from "@/reusable_sections/Header";
import NursingCaregiverAshkelonHero from "./sections/NursingCaregiverAshkelonHero";
import LocationsAndPavilionsInAshkelon from "./sections/LocationsAndPavilionsInAshkelon";
import LocalServicesInCandiac from "./sections/LocalServicesInCandiac";
import ReadyToGetStarted from "./sections/ReadyToGetStarted";
import BookYourSaintHubertService from "./sections/BookYourSaintHubertService";
import Footer from "@/reusable_sections/Footer";
export default function NursingCareProviderInAshkelonWithinFiveHoursPage() {
  return <div>
      <Header />
      <NursingCaregiverAshkelonHero />
      <LocationsAndPavilionsInAshkelon />
      <LocalServicesInCandiac />
      <ReadyToGetStarted />
      <BookYourSaintHubertService />
      <Footer />
    </div>;
}